import { render } from "./CarriersDetails.vue?vue&type=template&id=e39bbe42&scoped=true"
import script from "./CarriersDetails.vue?vue&type=script&lang=js"
export * from "./CarriersDetails.vue?vue&type=script&lang=js"

import "./CarriersDetails.vue?vue&type=style&index=0&id=e39bbe42&lang=scss"
import "./CarriersDetails.vue?vue&type=style&index=1&id=e39bbe42&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e39bbe42"]])

export default __exports__